<template>
  <b-container fluid>
    <b-row>
     <b-col :lg="cols">
        <card>
          <TableActionHeader v-on:filterChange="onFilterChange" v-on:newItem="onNewItem"></TableActionHeader> 
          <VirtualStopsTable :filter="filter" v-on:selectItem="onSelectItem"></VirtualStopsTable>               
        </card>
      </b-col>
      <b-col>
        <InfoCard v-if="action == ''"></InfoCard>
        <card v-if="action == 'new'">
          <CardHeader :title="$t('item.new')" />
          <VirtualStopsForm :item="item" :action="action"></VirtualStopsForm>                  
        </card>
        <card v-if="action == 'edit'">
          <CardHeader :title="item ? item.nimi : ''" type="item" />
          <VirtualStopsForm :item="item" :action="action"></VirtualStopsForm>                  
        </card>
      </b-col>
     </b-row>
  </b-container>

</template>

<script>

import TableActionHeader from '@/components/Misc/TableActionHeader'
import CardHeader from '@/components/Misc/CardHeader'
import VirtualStopsTable from '@/components/System/VirtualStops/VirtualStopsTable'
import VirtualStopsForm from '@/components/System/VirtualStops/VirtualStopsForm'

export default {
    components: {
        TableActionHeader, 
        CardHeader, 
        VirtualStopsTable, 
        VirtualStopsForm
    },
    data() {
        return {
            filter: null,
            item: {},
            cols:8,
            action: ""
        }        
    },
    methods: {
        onFilterChange: function(filter) {
            this.filter = filter;
        },
        onNewItem: function() {
            this.item = {};        
            this.action = "new"
        },
        onItemUpdated: function(item) {
            this.item = JSON.parse(JSON.stringify(item));                    
            this.action = "edit";
        },
        onSelectItem: function(item) { 
            this.item = item ? JSON.parse(JSON.stringify(item)) : {};            
            this.action = item ? "edit" : "";
        }
    }
}

</script>